import clsx from 'clsx';
import monsieurAvatar from '../../../../../styles/img/account/monsieurAvatar.svg';
import madameAvatar from '../../../../../styles/img/account/madameAvatar.svg';
import { useEffect } from 'react';
import { useFidCardFunnelTracking } from '../../../../../posthog/funnelTrackingFidCard';

const CivilityStep = ({ value, onChange }) => {
  const civilityOptions = [
    { label: "M.", value: "M", avatar: monsieurAvatar },
    { label: "Mme", value: "Mme", avatar: madameAvatar },
  ];

  const { trackPageViewCreateCivility } = useFidCardFunnelTracking();

  useEffect(() => {
    trackPageViewCreateCivility({});
  }, []);

  return (
    <div className="flex gap-6 justify-center flex-col appear">
      {civilityOptions.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={clsx(
            'flex items-center justify-start gap-2 w-full',
            'min-h-20 shadow-[0px_6px_0px_0px_#e2e2e2]',
            'px-6 py-6 border active:opacity-100',
            'transition-all duration-200 !rounded-2xl',
            {
              'bg-[#ECED90] text-[#596802] geomanistBold border-[#596802] shadow-[0px_6px_0px_0px_#596802]': value === option.value,
              'bg-white text-gray-700 border-gray-200': value !== option.value,
            }
          )}
        >
          <img src={option.avatar} alt={option.label} className="w-18 h-18" />
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default CivilityStep;
